import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';
import {
  addIdToSegmentationValueData,
  type RevenueInsightSegmentationValue,
} from 'lumen/utils/revenue-insight/model-utils';
import { v4 as uuidv4 } from 'uuid';

type RevenueInsightKpisResponse = {
  all: RevenueInsightSegmentationValue;

  impact_date: RevenueInsightSegmentationValue[];
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class RevenueInsightKpisRequestSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    all: { embedded: 'always' },
    impact_date: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  extractId() {
    return uuidv4();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeQueryRecordResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: RevenueInsightKpisResponse,
    id: string | number,
    requestType: string,
  ) {
    // Add `id` to each segmentation-value's segmentation-data object.
    // Necessary because backend does not provide an `id` for these objects.
    // Can't use extractId in revenue-insight/segmentation-data as we want existing store instances
    // to be overwritten when e.g. a new filter is applied (should result in same id).
    addIdToSegmentationValueData(payload.all);
    payload.impact_date.forEach((segmentationValue) => {
      addIdToSegmentationValueData(segmentationValue);
    });

    // Wrap the payload in a root key that matches the model name
    const restPayload = { [primaryModelClass.modelName]: payload };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeQueryRecordResponse(
      store,
      primaryModelClass,
      restPayload,
      id,
      requestType,
    );
  }
}
